var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-tooltip-wrapper"},[_c('v-tooltip',{attrs:{"top":"","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"info-tooltip-icon",class:{'info-tooltip-icon-force-show': _vm.forceShow},attrs:{"color":"#393C41","size":"8"}},on),[_vm._v("fa-info")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }